import { toast, useApiClient } from '@startupquickstart/frontend';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateChallengePinInput {
  challengeId: string;
  latitude: number;
  longitude: number;
}

/**
 * Persists a library challenge pin move (PATCH /challenges/:id) — the base
 * location in the challenge → template → event hierarchy. Moving it here shifts
 * the pin for every template/event that inherits it (see
 * docs/CHALLENGE_LOCATION_HIERARCHY.md).
 */
export function useUpdateChallengePin() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ challengeId, latitude, longitude }: UpdateChallengePinInput) =>
      apiClient.patch(`/challenges/${challengeId}`, { latitude, longitude }),
    onSuccess: (_data, { challengeId }) => {
      void queryClient.invalidateQueries({ queryKey: ['ChallengePins'] });
      void queryClient.invalidateQueries({ queryKey: ['challenges'] });
      void queryClient.invalidateQueries({ queryKey: ['challenge', challengeId] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update location');
    },
  });
}
